import React from "react";

import { Card, CardContent, Grid } from "@material-ui/core";

import { SERVICE_TYPES } from "../../../config/constants";
import { PlasticBagconfigurationViewUtils, ServiceActiveFlagViewUtils } from "../CountrySettingView";
import { ADVANCE_DAYS_DDN_OPTIONS, COUNTRY_SETTING_TEXT_CONSTANT, SlotBasedConfigInterface } from "../CountrySettingsUtils";

import RenderAdvanceSlotDays from "./RenderAdvanceSlotDays";
import RadioGroupField from "components/common/RadioGroupField/RadioGroupField";
import { ON_OFF_OPTIONS } from "components/common/App/app-constant";

interface RenderStandardServiceTypeDetailsInterface {
  classes: any;
  standardDetails: SlotBasedConfigInterface;
  handleStandardDetailsChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleBagChargeChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleAdvanceDaysClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  handleServiceTypeActiveChange: (event: React.ChangeEvent<HTMLInputElement>, serviceTypeName: string) => void;
  handlePlasticBagChange: (event: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  handleEditBagCharges: (name: string) => void;
  serviceTypeName: string;
}

const RenderStandardServiceTypeDetails = (props: RenderStandardServiceTypeDetailsInterface) => {
  const {
    classes,
    standardDetails,
    serviceTypeName,
    handleStandardDetailsChange,
    handleBagChargeChange,
    handleAdvanceDaysClick,
    handleServiceTypeActiveChange,
    handlePlasticBagChange,
    handleEditBagCharges,
  } = props;

  return (
    <Card className={classes.serviceTypeCard}>
      <CardContent>
        <Grid container justifyContent="flex-start" spacing={1}>
          <ServiceActiveFlagViewUtils
            classes={classes}
            serviceTypeName={serviceTypeName}
            serviceActiveFlag={standardDetails.serviceActive}
            isDisabled={false}
            handleServiceTypeActiveChange={handleServiceTypeActiveChange}
          />
          <RadioGroupField
            title={COUNTRY_SETTING_TEXT_CONSTANT.NEXT_DAY_SLOT_VISIBILITY}
            name={COUNTRY_SETTING_TEXT_CONSTANT.KEY_STANDARD_NEXT_DAYS_SLOT_VISIBILITY}
            value={standardDetails.nextDaySlotVisibility}
            options={ON_OFF_OPTIONS}
            handleChange={handleStandardDetailsChange}
            classes={classes}
            xs={2}
          />
          <PlasticBagconfigurationViewUtils
            classes={classes}
            bagChargeEnabled={standardDetails.bagChargeEnabled}
            handleBagChargeChange={handleBagChargeChange}
            name={serviceTypeName ?? SERVICE_TYPES.STANDARD}
            itemsPerBag={standardDetails.itemsPerBag}
            bagCharges={standardDetails.bagCharges}
            editBagCharge={standardDetails.editBagCharge}
            handleEditBagCharges={handleEditBagCharges}
            handlePlasticBagChange={handlePlasticBagChange}
            newPlasticBagCharges={standardDetails.newPlasticBagCharges}
          />
          <RenderAdvanceSlotDays
            classes={classes}
            advanceSlotDays={standardDetails.advanceSlotDays}
            showAdvanceSlotDaysInput={standardDetails.showAdvanceSlotDaysInput}
            menuItems={ADVANCE_DAYS_DDN_OPTIONS}
            name={"standardAdvanceSlotDays"}
            value={standardDetails.editSlotDays || standardDetails.advanceSlotDays}
            handleChange={handleStandardDetailsChange}
            handleAdvanceDaysClick={handleAdvanceDaysClick}
            serviceTypeName={serviceTypeName}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default React.memo(RenderStandardServiceTypeDetails);
